import { IBoolResult } from '@/types/dto';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/api/admin/agent/actions/setDomain';

interface IRequest {
  securityKey: string;
  hostDomain: string;
  siteId: number;
  siteDomain: string;
}

export default {
  setDomain(hostName: string, nodeName: string, isHongKong: boolean, req: IRequest, success: (res: IBoolResult) => void) {
    const hostRequest = utils.getHostRequest(hostName, nodeName, isHongKong);
    hostRequest
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },
};
